import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { TypePriority } from '../../../interfaces'

export const getTypePriority = (
  page: number,
  pageSize: number,
  nameFilter: string
) => {
  const url = new URL(ApiConfig.TypePriorityApi)

  if (nameFilter) {
    url.searchParams.set('name', nameFilter)
  }

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  return axios.get(url.toString())
}

export const createTypePriority = (dto: TypePriority) => {
  const url = new URL(ApiConfig.TypePriorityApi)

  return axios.post(url.toString(), dto)
}

export const putTypePriority = (dto: TypePriority) => {
  const url = new URL(`${ApiConfig.TypePriorityApi}/${dto.typePriorityId}`)

  return axios.put(url.toString(), dto)
}
